/** Cross-page CRM refresh — pickers and lists reload when linked entities change. */

export const CRM_CONTACTS_REFRESH_EVENT = 'crm-contacts-changed';
export const CRM_LEADS_REFRESH_EVENT = 'crm-leads-changed';
export const CRM_OPPORTUNITIES_REFRESH_EVENT = 'crm-opportunities-changed';
export const CRM_CAMPAIGNS_REFRESH_EVENT = 'crm-campaigns-changed';
export const CRM_INTERACTIONS_REFRESH_EVENT = 'crm-interactions-changed';
export const CRM_SALES_GOALS_REFRESH_EVENT = 'crm-sales-goals-changed';
export const CRM_SALES_AGENTS_REFRESH_EVENT = 'crm-sales-agents-changed';
export const CRM_TIMELINE_REFRESH_EVENT = 'crm-timeline-changed';
export const CRM_SUPPORT_TICKETS_REFRESH_EVENT = 'crm-support-tickets-changed';
export const CRM_DOCUMENTS_REFRESH_EVENT = 'crm-documents-changed';
export const FACTURATION_CLIENTS_REFRESH_EVENT = 'facturation-clients-changed';

export const CRM_REFRESH_BY_API = {
  '/crm/contacts': CRM_CONTACTS_REFRESH_EVENT,
  '/crm/leads': CRM_LEADS_REFRESH_EVENT,
  '/crm/opportunities': CRM_OPPORTUNITIES_REFRESH_EVENT,
  '/crm/campaigns': CRM_CAMPAIGNS_REFRESH_EVENT,
  '/crm/interactions': CRM_INTERACTIONS_REFRESH_EVENT,
  '/crm/sales-goals': CRM_SALES_GOALS_REFRESH_EVENT,
  '/crm/sales-agents': CRM_SALES_AGENTS_REFRESH_EVENT,
  '/crm/timeline': CRM_TIMELINE_REFRESH_EVENT,
  '/crm/support-tickets': CRM_SUPPORT_TICKETS_REFRESH_EVENT,
  '/crm/documents': CRM_DOCUMENTS_REFRESH_EVENT,
  '/facturation/clients': FACTURATION_CLIENTS_REFRESH_EVENT,
};

/** All CRM entity events — dashboard/analytics can listen once. */
export const ALL_CRM_DATA_REFRESH_EVENTS = [
  CRM_CONTACTS_REFRESH_EVENT,
  CRM_LEADS_REFRESH_EVENT,
  CRM_OPPORTUNITIES_REFRESH_EVENT,
  CRM_CAMPAIGNS_REFRESH_EVENT,
  CRM_INTERACTIONS_REFRESH_EVENT,
  CRM_SALES_GOALS_REFRESH_EVENT,
  CRM_SALES_AGENTS_REFRESH_EVENT,
  CRM_TIMELINE_REFRESH_EVENT,
  CRM_SUPPORT_TICKETS_REFRESH_EVENT,
  CRM_DOCUMENTS_REFRESH_EVENT,
  FACTURATION_CLIENTS_REFRESH_EVENT,
];

export function dispatchCrmApiRefresh(apiPath) {
  const eventName = CRM_REFRESH_BY_API[apiPath];
  if (eventName && typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(eventName));
  }
}
